<template>
    <div class="form-horizontal" v-if="!!user" id="managers-page">
        <div class="row">
            <div class="col-md-6">
                <h1>Leidinggevenden</h1>
            </div>
            <div class="col-md-6 text-right mt-2">
                <button class="btn btn-outline-azure-dark" @click="add">
                    <font-awesome-icon icon="plus"></font-awesome-icon> Toevoegen
                </button>
                <div v-if="isLoading" class="inline ml-3">
                    <loader width="2rem"></loader>
                </div>
                <button class="btn btn-success ml-3" @click="save" v-else-if="$v.managers.$dirty">
                    <font-awesome-icon icon="save"></font-awesome-icon> Opslaan
                </button>
            </div>
        </div>
        <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>Naam</th>
                    <th>Email</th>
                    <th>Telefoon (1)</th>
                    <th>Telefoon (2)</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(manager, index) in managers" :key="index">
                    <td>
                        <input type="text" class="form-control" v-model="manager.name"
                        name="name"
                        :disabled="isLoading"
                        @change="$v.managers.$touch()"
                        :class="['form-control', ($v.managers.$each[index.toString()].name.$dirty) ? ($v.managers.$each[index.toString()].name.$error) ?'is-invalid' : 'is-valid' : '']" />
                    </td>
                    <td>
                        <input type="email" class="form-control" v-model="manager.email" 
                        name="email"
                        :disabled="isLoading"
                        @change="$v.managers.$touch()"
                        :class="['form-control', ($v.managers.$each[index.toString()].email.$dirty) ? ($v.managers.$each[index.toString()].email.$error) ?'is-invalid' : 'is-valid' : '']" />
                    </td>
                    <td>
                        <input type="tel" class="form-control" v-model="manager.phoneNumber"
                        name="phoneNumber"
                        :disabled="isLoading"
                        @change="$v.managers.$touch()"
                        :class="['form-control', ($v.managers.$each[index.toString()].phoneNumber.$dirty) ? ($v.managers.$each[index.toString()].phoneNumber.$error) ?'is-invalid' : 'is-valid' : '']" />
                    </td>
                    <td>
                        <input type="tel" class="form-control" v-model="manager.altPhoneNumber"
                        name="altPhoneNumber"
                        :disabled="isLoading"
                        @change="$v.managers.$touch()"
                        :class="['form-control', ($v.managers.$each[index.toString()].altPhoneNumber.$dirty) ? ($v.managers.$each[index.toString()].altPhoneNumber.$error) ?'is-invalid' : 'is-valid' : '']" />
                    </td>
                    <td>
                        <button class="btn btn-danger btn-sm" @click="remove(manager)"><font-awesome-icon icon="trash-alt" ></font-awesome-icon></button>
                    </td>
                </tr>
            </tbody>
        </table>
        </div>
    </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, helpers, email, or } from 'vuelidate/lib/validators';
import Loader from '@/components/Loader';

const mobile = helpers.regex('mobile', /^(((\\+31|0|0031)6){1}[1-9]{1}[0-9]{7}|((\\+31|0|0031)6)[-]{1}[1-9]{1}[0-9]{7})$/);
const landline = helpers.regex('landline', /^(((0)[1-9]{2}[0-9][-]?[1-9][0-9]{5})|((\\+31|0|0031)[1-9][0-9][-]?[1-9][0-9]{6}))$/);

const arrayNotEmpty = (value) => {
    if(value.length > 0)
        return true;
    return false;
}
export default {
    props: ['user'],
    mixins: [validationMixin],
    components: {
        'loader': Loader
    },
    data() {
        return {
            isLoading: false,
            managers: []
        }
    },
    validations: {
        managers: {
            //arrayNotEmpty,
            $each: {
                name: {
                    required
                },
                email: {
                    required,
                    email
                },
                phoneNumber: {
                    required,
                    or: or(landline, mobile)
                },
                altPhoneNumber: {
                    or: or(landline, mobile)
                }
            }
        }
    },
    mounted() {
        this.get();
    },
    methods: {
        add() {
            this.$v.managers.$touch()
            if(!this.$v.managers.$invalid)
            {
                this.managers.push({
                    id: -this.managers.length,
                    name: null,
                    email: null,
                    phoneNumber: null,
                    altPhoneNumber: null
                });
            }
        },
        get() {
            this.isLoading = true;
            this.$http.get("api/Managers").then((res) => {
                this.managers = res.data;
                this.isLoading = false;
            }); 
        },
        save() {
            this.isLoading = true;
            return this.$http.post("api/Managers", this.managers).then((res) => {
                this.$v.$reset();
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            })
        },
        remove(manager)
        {
            if(this.managers.length > 1)
            {
                this.isLoading = true;
                this.$http.delete("api/Managers/" + manager.id).finally(() => {
                    this.managers.splice(this.managers.indexOf(manager), 1);
                    this.isLoading = false;
                })
            }
        }
    },
    computed: {
        profile() {
            if(this.user)
                return this.user.clientProfile;
            return {};
        },
    }
}
</script>

<style scoped>
.img-profile {
    width: 75%;
    height: 75%;
}
</style>

